export const formatParentDataIntoOTelFormat = (parentData) =>{
    try {
        const result = {
            id: parentData.id,
            l_id: parentData.l_id
          };
        
          // Include primaryCol only if it exists
          if ('primaryCol' in parentData) {
            result.primaryCol = parentData.primaryCol;
          }

          if ('#' in parentData) {
            result["#"] = parentData["#"];
          }
        
          return result;
    } catch (error) {
        console.error("Error in formatParentDataIntoOTelFormat",error);
        
    }
}

export const formatArrayforLogs = (arr) => {
    try {
        if (arr && arr.length > 0) {
            let newArray = arr.map((row) => {
                return formatParentDataIntoOTelFormat(row);
            })
            return newArray
        }
        else return []
    } catch (error) {
        console.error("Error in formatArrayforLogs", error);
    }
}

export const formatundostackData = (undoData) =>{
    try {
        let updatedUndoData = [];
        if(undoData && undoData.length >0){
            updatedUndoData = undoData.map((obj)=>{
                let newobj = {...obj}
                if(newobj){
                    if(newobj.cellRows && newobj.cellRows.length>0){
                        newobj.cellRows = formatArrayforLogs(newobj.cellRows)
                    }
                    if(newobj.previousRows && newobj.previousRows.length>0){
                        newobj.previousRows = formatArrayforLogs(newobj.previousRows)
                    }
                }

                return newobj;
            })

            return updatedUndoData;
        }

        return updatedUndoData;
    } catch (error) {
        console.error("Error in formatParentDataIntoOTelFormat",error);
        
    }
}

export const formatForSingleRowNode = (rowNode) =>{
  try {
      if(rowNode){
        const formatted = {
          rowIndex: rowNode.rowIndex ?? null,
          sourceRowIndex: rowNode.sourceRowIndex ?? null,
          allChildrenCount: rowNode.allChildrenCount ?? 0,
          data: formatParentDataIntoOTelFormat(rowNode.data ?? {}),
        };
  
        return formatted;
      }else{
        return {}
      }
  } catch (error) {
      console.error("Error in formatParentDataIntoOTelFormat",error);
      
  }
}

export const formatRowNodesForLogs = (rowNodes) => {
    try {
      if (!rowNodes || rowNodes.length === 0) return [];
  
      return rowNodes.map((row) => {
        const formatted = {
          rowIndex: row.rowIndex ?? null,
          sourceRowIndex: row.sourceRowIndex ?? null,
          allChildrenCount: row.allChildrenCount ?? 0,
          data: formatParentDataIntoOTelFormat(row.data ?? {}),
        };
  
        return formatted;
      });
    } catch (error) {
      console.error("Error in formatRowNodesForLogs", error);
      return [];
    }
  };


export const formatCategorizeUpdateRows = (updatedRows) => {
  try {
    if (!updatedRows || typeof updatedRows !== "object") return {};

    const formatted = {};

    // Handle "update" rows
    if (Array.isArray(updatedRows.update) && updatedRows.update.length > 0) {
      formatted.update = formatArrayforLogs(updatedRows.update);
    }
 if (Array.isArray(updatedRows.delete) && updatedRows.delete.length > 0) {
      formatted.delete = formatArrayforLogs(updatedRows.delete);
    }
    // Handle "add" rows → specifically allRowsAdded
    if (
      updatedRows.add &&
      Array.isArray(updatedRows.add.addedRows) &&
      updatedRows.add.addedRows.length > 0
    ) {
      formatted.add = {};
      formatted.add.addedRows = formatArrayforLogs(updatedRows.add.addedRows);
    }

    return formatted;
  } catch (error) {
    console.error("Error in formatCategorizeUpdateRows", error);
    return {};
  }
};


 export const formatgridChangesPerSaveSessionLocalVariable = (gridChangesPerSaveSessionLocalVariable) => {
  try {
    if (
      !gridChangesPerSaveSessionLocalVariable ||
      typeof gridChangesPerSaveSessionLocalVariable !== "object"
    ) {
      return {};
    }
    const result = {};

    // Handle 'update' property
    if (
      gridChangesPerSaveSessionLocalVariable.update &&
      typeof gridChangesPerSaveSessionLocalVariable.update === "object"
    ) {
      result.update = {};

      Object.entries(gridChangesPerSaveSessionLocalVariable.update).forEach(
        ([key, rowData]) => {
          result.update[key] = formatParentDataIntoOTelFormat(rowData);
        }
      );
    }
 if (
      gridChangesPerSaveSessionLocalVariable.delete &&
      typeof gridChangesPerSaveSessionLocalVariable.delete === "object"
    ) {
      result.delete = {};

      Object.entries(gridChangesPerSaveSessionLocalVariable.delete).forEach(
        ([key, rowData]) => {
          result.delete[key] = formatParentDataIntoOTelFormat(rowData);
        }
      );
    }
    // Handle 'add' property (object where values are arrays of rows)
    if (
      gridChangesPerSaveSessionLocalVariable.add &&
      typeof gridChangesPerSaveSessionLocalVariable.add === "object"
    ) {
      result.add = {};

      Object.entries(gridChangesPerSaveSessionLocalVariable.add).forEach(
        ([key, rows]) => {
          if (Array.isArray(rows) && rows.length > 0) {
            result.add[key] = formatArrayforLogs(rows);
          } else {
            result.add[key] = [];
          }
        }
      );
    }

    // TODO: handle delete, addedRowsBelowNodeMap if needed later

    return result;
  } catch (error) {
    console.error("Error in formatgridChangesPerSaveSessionLocalVariable", error);
    return {};
  }
};



  export const formatRowArrayOfOutdentForLogs = (arr) => {
    try {
      if (!Array.isArray(arr)) return [];
  
      return arr.map((item, idx) => {
        return {
          rowIndex: item.rowIndex ?? idx, // fallback to array index if missing
          row: formatParentDataIntoOTelFormat(item.row || {})
        };
      });
    } catch (error) {
      console.error("Error in formatRowArrayForLogs", error);
      return [];
    }
  };

  export const formatUndoRowFordragFunc = (obj) =>{
    try {
      if (!obj || typeof obj !== "object") {
        return {};
      }
      return {
        action: obj.action,
        belowNodeId: obj.belowNodeId,
        direction: obj.direction,
        index : obj.index,
        overIndex :obj.overIndex,
        type : obj.type,
        prefixl_idForUndo : obj.prefixl_idForUndo,
        overNodeId : obj.overNodeId,
        cellRows: formatArrayforLogs(obj.cellRows),
        draggedNode : {
          rowIndex: obj.draggedNode.rowIndex ?? null,
          sourceRowIndex: obj.draggedNode.sourceRowIndex ?? null,
          allChildrenCount: obj.draggedNode.allChildrenCount ?? 0,
          data: formatParentDataIntoOTelFormat(obj.draggedNode.data ?? {})
        },
        overNode : {
          rowIndex: obj.overNode.rowIndex ?? null,
          sourceRowIndex: obj.overNode.sourceRowIndex ?? null,
          allChildrenCount: obj.overNode.allChildrenCount ?? 0,
          data: formatParentDataIntoOTelFormat(obj.overNode.data ?? {})
        },
        previousRows : formatArrayforLogs(obj.previousRows??[]),
        updatedRows : formatArrayforLogs(obj.updatedRows??[]),
        rowData : formatArrayforLogs(obj.rowData??[]),
      };


    } catch (error) {
        console.error("Error in formatUndoRowFordragFunc",error);
        
    }
}

export const formatdropIndexInOutdent = (obj) =>{
  try {
    if (!obj || typeof obj !== "object") {
      return {};
    }

    return {
      add : formatRowNodesForLogs(obj.add ?? []),
      remove :  formatRowNodesForLogs(obj.remove ?? []),
      update : formatRowNodesForLogs(obj.update ?? []),
    }
  } catch (error) {
      console.error("Error in formatParentDataIntoOTelFormat",error);
      
  }
}
// Function to format undoInfo before logging
export const formatInsertUndoInfoForLogs = (undoInfo) => {
  try {
    if (!undoInfo) return {};

    return {
      type: undoInfo.type ?? null,
      action: undoInfo.action ?? null,
      belowNodeId: undoInfo.belowNodeId ?? null,
      above: undoInfo.above ?? null,

      // Apply formatters
      aboveNode: formatForSingleRowNode(undoInfo.aboveNode),
      allRowsAdded: formatArrayforLogs(undoInfo.allRowsAdded),

      // Keep arrays/objects as they are (you can plug in your formatter later if needed       updatedRows: formatArrayforLogs(undoInfo.updatedRows),
      undoUpdatedRows: formatArrayforLogs(undoInfo.undoUpdatedRows),
    };
  } catch (error) {
    console.error("Error in formatUndoInfoForLogs", error);
    return { error: "SerializationFailed", message: error.message };
  }
};

export const formatDeleteUndoInfo = (undoInfo) => {
  try {
    if (!undoInfo || typeof undoInfo !== "object") return {};

    let formatted = {...undoInfo};

    // Single node
    if (undoInfo.NodeToCollapseNode) {
      formatted.NodeToCollapseNode = formatForSingleRowNode(undoInfo.NodeToCollapseNode);
    }

    // Arrays of row nodes
    if (Array.isArray(undoInfo.rowsToDelete) && undoInfo.rowsToDelete.length > 0) {
      formatted.rowsToDelete = undoInfo.rowsToDelete.map((node) =>
        formatForSingleRowNode(node)
      );
    }

    // Arrays of row objects
    if (Array.isArray(undoInfo.parentRowsAffectedByRollup) && undoInfo.parentRowsAffectedByRollup.length > 0) {
      formatted.parentRowsAffectedByRollup = formatArrayforLogs(undoInfo.parentRowsAffectedByRollup);
    }

    if (Array.isArray(undoInfo.addedRowsAfterDeletion) && undoInfo.addedRowsAfterDeletion.length > 0) {
      formatted.addedRowsAfterDeletion = formatArrayforLogs(undoInfo.addedRowsAfterDeletion);
    }

    if (Array.isArray(undoInfo.extraRowsForPredecessor) && undoInfo.extraRowsForPredecessor.length > 0) {
      formatted.extraRowsForPredecessor = formatArrayforLogs(undoInfo.extraRowsForPredecessor);
    }

    if (Array.isArray(undoInfo.undoRowsForPredecessor) && undoInfo.undoRowsForPredecessor.length > 0) {
      formatted.undoRowsForPredecessor = formatArrayforLogs(undoInfo.undoRowsForPredecessor);
    }

    if (Array.isArray(undoInfo.successorNodesForRowUndoForRowDelete) && undoInfo.successorNodesForRowUndoForRowDelete.length > 0) {
      formatted.successorNodesForRowUndoForRowDelete = undoInfo.successorNodesForRowUndoForRowDelete
        .filter((n) => n !== undefined && n !== null)
        .map((node) => formatForSingleRowNode(node));
    }

    // simple values (numbers/ids)
    if (Array.isArray(undoInfo.selectedRowIndexes) && undoInfo.selectedRowIndexes.length > 0) {
      formatted.selectedRowIndexes = [...undoInfo.selectedRowIndexes];
    }

    return formatted;
  } catch (error) {
    console.error("Error in formatDeleteUndoInfo", error);
    return {};
  }
};
export const formatPasteRowObjectMap = (rowsObj) => {
  try {
    if (!rowsObj || typeof rowsObj !== "object") return [];

    return Object.values(rowsObj).map((row) => {
      // Pick id and l_id
      const formatted = {
        id: row.id ?? null,
        l_id: row.l_id ?? null,
      };

      // Pick all Column* fields (but skip *_es)
      Object.keys(row).forEach((key) => {
        if (/^Column\d+$/.test(key) || key === "primaryCol") {
          formatted[key] = row[key];
        }
      });

      return formatted;
    });
  } catch (error) {
    console.error("Error in formatRowObjectMap", error);
    return [];
  }
};
// keep only colId, field, type from column
const formatColumn = (column) => {
  if (!column || typeof column !== "object") return {};
  const { colId, field, type } = column;
  return { colId, field, type };
};


// format entire cellValueCallBackArray without breaking structure
export const formatCellValueCallBackArray = (cellValueCallBackArray) => {
  try {
    if (!cellValueCallBackArray?.current?.calls) return cellValueCallBackArray;

    return {
      ...cellValueCallBackArray,
      current: {
        ...cellValueCallBackArray.current,
        calls: cellValueCallBackArray.current.calls.map((call) => {
          const formattedCall = { ...call };

          // format row
          if (formattedCall.row) {
            formattedCall.row = formatArrayforLogs(formattedCall.row);
          }

          // format undoRow
          if (formattedCall.undoRow) {
            formattedCall.undoRow = {
              ...formattedCall.undoRow,
              column: formatColumn(formattedCall.undoRow.column),
              rowData: formatArrayforLogs(formattedCall.undoRow.rowData),
            };
          }

          return formattedCall;
        }),
      },
    };
  } catch (err) {
    console.error("Error in formatCellValueCallBackArray", err);
    return cellValueCallBackArray;
  }
};


export const abc = (parentData) =>{
    try {
        
    } catch (error) {
        console.error("Error in formatParentDataIntoOTelFormat",error);
        
    }
}